import { useCallback, useEffect, useState } from 'react';
import { Hook, ScheduleRedirect, ScheduleRedirectInput } from './redirect.types';

export const useRedirect: Hook = () => {
  const [action, setAction] = useState<ScheduleRedirectInput | null>(null);

  useEffect(() => {
    if (action) {
      console.info('Scheduler de redirecionamento para url: ', action.url);
      console.info('Scheduler de redirecionamento para tempo: ', action.seconds);
      const pid = setTimeout(() => {
        window.open(action.url, '_self');
      }, action.seconds * 1000);
      return () => {
        clearTimeout(pid);
      };
    }
  }, [action]);

  const scheduleRedirect = useCallback<ScheduleRedirect>(
    (input) => {
      setAction(input);
    },
    [setAction],
  );

  return { scheduleRedirect };
};
